// material
import {Card, Container, Typography} from '@mui/material';
import {AdminLoginForm} from '../../components/authentication/login';
import {getTestFlag} from 'src/getTestFlag';
import {Link} from 'react-router-dom';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function AdminLogin() {
	return (
		<Container maxWidth="sm">
			<Card sx={{p: 4}}>
				<Typography variant="h4" gutterBottom>
					تسجيل الدخول
				</Typography>

				{<AdminLoginForm />}

				{getTestFlag('test_mode') && (
					<Link to="/forget-password" passHref>
						<Typography mt={2} sx={{cursor: 'pointer'}} color="primary" textAlign="right">
							هل نسيت كلمة المرور؟
						</Typography>
					</Link>
				)}
			</Card>
		</Container>
	);
}
